import React, {FC} from "react";
import styled from 'styled-components';
import {
    ProfileBeaconTable,
    ProfileBeaconTableHeader,
    ProfileBeaconTableRecord
} from './ProfileBeaconComponents';
import {getWebDomain} from "../../utils/api";
import Button from "./Button";
import {UseAppSelector} from "../../redux/configure-store";
import {getSelectedPlan} from "../../redux/profile/selectors";
interface Props {
    variant?: string;
    headerNames: Array<any>;
    tableColumnData: Array<any>;
    isMarginalTaxRateModal?: boolean;
}

const StyledTable = styled(ProfileBeaconTable)`
  margin-top: 24px;
  th {
    padding: 24px !important;
  }
  td {
    padding: 24px !important;
  }
  tbody th {
    padding: 24px !important;
  }
  tbody td {
    padding: 24px !important;
  }
  @media(max-width: 768px){
    th {
      padding: 16px 12px !important;
    }
    tbody td {
      padding: 16px 12px !important;
    }
  }
  @media(max-width: 640px){
     th {
      padding: 16px 12px !important;
    }
    tbody td {
      padding: ${({isMarginalTaxRateModal}) => isMarginalTaxRateModal ? "16px 5px !important" : "16px 12px !important"};
    }
  }
  //--beacon-custom-table-container-block-size: 70vh; /* We use 80vh as an example but this could be any fixed height */
  --beacon-custom-table-container-overflow-x: auto;
`;

const StyledTableRightHeader = styled(ProfileBeaconTableHeader)`
    font-weight: var(--beacon-font-weight-bold);
    float: right;
    width: 110px;
    --beacon-cell-space-padding: 0;
    --text-cell-padding-inline-start: 0;
    --beacon-table-header-1st-cell-space-padding-inline-start:0;
    --text-cell-padding-block-start:0;
    --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
    --beacon-table-header-last-cell-space-padding-inline:0;
    --beacon-table-header-nth-cell-space-padding-inline-end:0;
    --beacon-table-header-nth-cell-space-padding-inline-start:0;
    text-align: right;
`;

const StyledTableActionHeader = styled(ProfileBeaconTableHeader)`
    font-weight: var(--beacon-font-weight-bold);
    float: right;
    width: 110px;
    --beacon-cell-space-padding: 0;
    --text-cell-padding-inline-start: 0;
    --beacon-table-header-1st-cell-space-padding-inline-start:0;
    --text-cell-padding-block-start:0;
    --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
    --beacon-table-header-last-cell-space-padding-inline:0;
    --beacon-table-header-nth-cell-space-padding-inline-end:0;
    --beacon-table-header-nth-cell-space-padding-inline-start:0;
    text-align: right;
`;

const StyledTableHeader = styled(ProfileBeaconTableHeader)`
    font-weight: var(--beacon-font-weight-bold);
    --beacon-cell-space-padding: 0;
    --text-cell-padding-inline-start: 0;
    --beacon-table-header-1st-cell-space-padding-inline-start:0;
    --text-cell-padding-block-start:0;
    --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
    --beacon-table-header-last-cell-space-padding-inline:0;
    --beacon-table-header-nth-cell-space-padding-inline-end:0;
    --beacon-table-header-nth-cell-space-padding-inline-start:0;
`;

const StyledTableRecord = styled(ProfileBeaconTableRecord)`
  font-size: 18px;
  --beacon-table-record-space-margin-inline-start-default: 0;
  --beacon-unit-subatomic: 0;
  --beacon-cell-space-padding: 0;
  --text-cell-padding-inline-start: 0;
  --beacon-table-header-1st-cell-space-padding-inline-start:0;
  --text-cell-padding-block-start:0;
  --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
  --beacon-table-header-last-cell-space-padding-inline:0;
  --beacon-table-record-space-margin-inline-end-default: 0;
  @media(max-width: 768px){
    font-size: 16px;
  }
`;

const StyledTaxRateTableRecord = styled(ProfileBeaconTableRecord)`
  color: #000000;
  text-align: right;
  --beacon-table-record-space-margin-inline-start-default: 0;
  --beacon-unit-subatomic: 0;
  --beacon-cell-space-padding: 0;
  --text-cell-padding-inline-start: 0;
  --beacon-table-header-1st-cell-space-padding-inline-start:0;
  --text-cell-padding-block-start:0;
  --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
  --beacon-table-header-last-cell-space-padding-inline:0;
  --beacon-table-record-space-margin-inline-end-default: 0;
`;

const StyledColumnRecord = styled(ProfileBeaconTableRecord)`
  color: #086ea1;
  font-weight: var(--beacon-font-weight-bold);
  --beacon-table-record-space-margin-inline-start-default: 0;
  --beacon-unit-subatomic: 0;
  --beacon-cell-space-padding: 0;
  --text-cell-padding-inline-start: 0;
  --beacon-table-header-1st-cell-space-padding-inline-start:0;
  --text-cell-padding-block-start:0;
  --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
  --beacon-table-header-last-cell-space-padding-inline:0;
`;

const StyledBeneTitle = styled(ProfileBeaconTableRecord)`
  color: #3b4b59;
  --beacon-table-record-space-margin-inline-start-default: 0;
  --beacon-unit-subatomic: 0;
  --beacon-cell-space-padding: 0;
  --text-cell-padding-inline-start: 0;
  --beacon-table-header-1st-cell-space-padding-inline-start:0;
  --text-cell-padding-block-start:0;
  --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
  --beacon-table-header-last-cell-space-padding-inline:0;
`;

const StyledTableNumberRecord = styled(ProfileBeaconTableRecord)`
  float: right;
  --beacon-table-record-space-margin-inline-end-default: 0;
  --beacon-table-record-space-margin-inline-start-default: 0;
  --beacon-unit-subatomic: 0;
  --beacon-cell-space-padding: 0;
  --text-cell-padding-inline-start: 0;
  --beacon-table-header-1st-cell-space-padding-inline-start:0;
  --text-cell-padding-block-start:0;
  --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
  --beacon-table-header-last-cell-space-padding-inline:0;
`;
const StyledSignUpRecord = styled(ProfileBeaconTableRecord)`
  color: #086ea1;
  float: right;
  --beacon-table-record-space-margin-inline-end-default: 0;
  font-weight: var(--beacon-font-weight-bold);
  --beacon-table-record-space-margin-inline-start-default: 0;
  --beacon-unit-subatomic: 0;
  --beacon-cell-space-padding: 0;
  --text-cell-padding-inline-start: 0;
  --beacon-table-header-1st-cell-space-padding-inline-start:0;
  --text-cell-padding-block-start:0;
  --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
  --beacon-table-header-last-cell-space-padding-inline:0;
`;
const Table: FC<Props> = ({   isBeneCard,
                              variant,
                              headerNames,
                              tableColumnData,
                              isMarginalTaxRateModal,
                              isSignupButtonDisable,
                              onlyMyBeneficiaries
                          }) => {
    const goToNewPage = (url) => {
        document.location.href = getWebDomain() + url;
    }

    const selectedPlan = UseAppSelector(getSelectedPlan);
    const planNumber = selectedPlan.value;
    return (
        <StyledTable isMarginalTaxRateModal={isMarginalTaxRateModal}>
            <table>
                <thead>
                <tr>
                    {headerNames.map((header) => {
                        return (
                            <>
                                <th scope="col">
                                    {header === "DISTRIBUTION %" ?
                                        <StyledTableRightHeader>
                                            {header}
                                        </StyledTableRightHeader> :
                                        header === "ACTION" ?
                                            <StyledTableActionHeader>
                                                {header}
                                            </StyledTableActionHeader>
                                            :
                                            <StyledTableHeader>
                                                {header}
                                            </StyledTableHeader>
                                    }
                                </th>
                            </>)
                    })}
                </tr>
                </thead>
                <tbody>
                {tableColumnData && tableColumnData.map((record) => {
                        return (
                            <>
                                <tr>
                                    {record && record.map((cellData: any) => {
                                            return (
                                                <td>
                                                    {cellData.name === "rate" ?
                                                        <StyledColumnRecord
                                                            variant="text"><strong>{Math.round(cellData.value * 100)}%</strong></StyledColumnRecord> :
                                                        cellData.name === "type" && onlyMyBeneficiaries ?
                                                          <StyledBeneTitle variant="text">
                                                            {'My Beneficiaries'}
                                                          </StyledBeneTitle> :
                                                        cellData.name === "action"?
                                                            <StyledSignUpRecord variant="text">
                                                                <Button variant="signUp" isLink={true} buttonTitle={cellData.value}
                                                                        disabled={isSignupButtonDisable}
                                                                        onBeaconClick={() => goToNewPage(`/rps/rws/account/participant/beneficiary-info.otc?accountKey=RPS_${planNumber}`) }/>
                                                            </StyledSignUpRecord> :
                                                            cellData.name === "distribution"?
                                                                <StyledTableNumberRecord
                                                                    variant="text">{cellData.value}%</StyledTableNumberRecord> :
                                                                isMarginalTaxRateModal ?
                                                                    <StyledTaxRateTableRecord variant="text">{cellData.value}</StyledTaxRateTableRecord> :
                                                                    <StyledTableRecord variant="text">{cellData.value}</StyledTableRecord>
                                                    }
                                                </td>
                                            )
                                        }
                                    )
                                    }
                                </tr>
                            </>
                        )
                    }
                )}
                </tbody>
            </table>
        </StyledTable>
    )
}
export default Table;